import { render, staticRenderFns } from "./WangEditor.vue?vue&type=template&id=575c9906&"
import script from "./WangEditor.vue?vue&type=script&lang=js&"
export * from "./WangEditor.vue?vue&type=script&lang=js&"
import style0 from "./WangEditor.vue?vue&type=style&index=0&id=575c9906&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports